import React, { useEffect, useMemo, useRef, useState } from "react";
import "./appointment.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAppointments } from "../../store/slices/appointmentSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowsRotate,
    faEye,
    faPenToSquare,
    faTrash,
    faTriangleExclamation,
    faUserPlus,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import CustomModal from "../../components/common/modal/modal";
import CreateAppointment from "../../components/appointment/create-appointment";
import Pagination from "react-js-pagination";
import { deleteAppointment } from "../../service/api/appointment-api";
import { createVisit } from "../../service/api/visit";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { formatAgeYearMonth, dateFormat, formatDate, resolveActingDoctorId } from "../../utils/common-funtions/common";
import PrescriptionPrint from "../../components/prescription/prescription-print/prescription-print";
import AppointmentFilter from "../../components/appointment/appointment-filter";
import { put } from "../../utils/fetchAPI";
import AppointmentDetailsShow from "../../components/appointment/appointment-details-show";
import { Toast } from "../../utils/SwalUti";
import { LocalStorageService } from "../../utils/local-storage";

const Appointment = () => {
    const dispatch = useDispatch();
    const [selectedRow, setSelectedRow] = useState();
    const ref = useRef([]);
    const keyRef = useRef()
    const [length, setLength] = useState(50);
    let { isLoading, pagination, allAppointments, noAppointmentFound } =
        useSelector((state) => state.appointment);
    const { currentPage, perPage, total } = pagination;
    const [show, setShow] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const [showPrint, setShowPrint] = useState(false);
    const [patientId, setPatientId] = useState()
    const [visitId, setVisitId] = useState()
    const [actionModal, setActionModal] = useState(false)
    const [enableButton, setEnableButton] = useState({ delete: false, appointmentDate: false, status: false })
    const navigate = useNavigate()
    const [appointmentUpdatedValue, setAppointmentUpdatedValue] = useState({})
    let filterLocalData = LocalStorageService.get("appointmentFilter")
    const { user, userRoles, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
    const actingDoctorId = resolveActingDoctorId({ user, selectedRole, selectedDoctor });

    const utcDate = new Date();
    let bdDate = utcDate.toLocaleDateString('en-US', { timeZone: 'Asia/Dhaka' });
    //let bdDate = utcDate.toLocaleDateString('en-US', {day: '2-digit', month: '2-digit', year: 'numeric',timeZone: 'Asia/Dhaka'});
    bdDate = bdDate.split('/')
    let date = `${bdDate[2]}-${bdDate[0].length == 1 ? ("0" + bdDate[0]) : bdDate[0]}-${bdDate[1]?.length == 1 ? ("0" + bdDate[1]) : bdDate[1]}`

    const utcDate1 = new Date();
    utcDate1.setDate(utcDate1.getDate() + 7);
    let bdDate1 = utcDate1.toLocaleDateString('en-US', { timeZone: 'Asia/Dhaka' });
    bdDate1 = bdDate1.split('/')
    let endDate = `${bdDate1[2]}-${bdDate1[0].length == 1 ? ("0" + bdDate1[0]) : bdDate1[0]}-${bdDate1[1]?.length == 1 ? ("0" + bdDate1[1]) : bdDate1[1]}`

    const [searchParams] = useSearchParams();
    const [filterDate, setFilterDate] = useState({ startDate: filterLocalData?.startDate || searchParams.get('startDate') || date?.slice(0, 10), endDate: filterLocalData?.endDate || searchParams.get('endDate') || endDate?.slice(0, 10) })
    const [currentDate, setCurrentDate] = useState(true)
    const [currentLocation, setCurrentLocation] = useState(filterLocalData?.locationId || searchParams.get('location') || '')
    const [currentDoctor, setCurrentDoctor] = useState(filterLocalData?.doctorId || searchParams.get('doctor') || '')
    const [status, setStatus] = useState(filterLocalData?.status || searchParams.get('status') || '')
    const [appointmentDate, setAppointmentDate] = useState('')
    const [dateChangeModal, setDateChangeModal] = useState(false)
    const [selectedAppointment, setSelectedAppointment] = useState({})
    const location = useLocation()


    // useEffect(() => {
    //     dispatch(
    //         getAppointments({
    //             search: "",
    //             per_page: filterLocalData?.per_page || length,
    //             current_page: filterLocalData?.current_page || currentPage,
    //             startDate: filterLocalData?.startDate || filterDate?.startDate,
    //             endDate: filterLocalData?.endDate || filterDate?.endDate,
    //             status: filterLocalData?.status || status,
    //             locationId: filterLocalData?.locationId || currentLocation || '',
    //             doctorId: filterLocalData?.doctorId || currentDoctor || ""
    //         })
    //     );
    // }, []);

    useMemo(() => {
        if (selectedRole?._id) {
            setCurrentLocation(selectedRole?.location?._id)
            setCurrentDoctor(actingDoctorId)
            dispatch(
                getAppointments({
                    search: "",
                    per_page: filterLocalData?.per_page || length,
                    current_page: filterLocalData?.current_page || currentPage,
                    startDate: filterLocalData?.startDate || filterDate?.startDate,
                    endDate: filterLocalData?.endDate || filterDate?.endDate,
                    status: filterLocalData?.status || status,
                    userRoleId: selectedRole?._id || '',
                    doctorId: actingDoctorId || ""
                })
            );
        }
    },
        [selectedRole?._id, selectedDoctor?._id])

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // console.log("event",e,ref.current)
            if (
                selectedRow &&
                ref.current[selectedRow] &&
                !ref.current[selectedRow].contains(e.target)
            ) {
                setSelectedRow(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [selectedRow]);

    const index = (page = 1, search = "", per_page = length, startDate = filterDate.startDate, endDate = filterDate?.endDate, statusVal = status, userRoleId = selectedRole?._id || '', doctorId = actingDoctorId || "") => {
        LocalStorageService.set('appointmentFilter', {
            per_page: per_page,
            current_page: page,
            startDate: startDate,
            endDate: endDate,
            status: statusVal,
            userRoleId: userRoleId,
            doctorId: doctorId
        })
        dispatch(
            getAppointments({
                search: search,
                per_page: per_page,
                current_page: page,
                startDate: startDate,
                endDate: endDate,
                status: statusVal,
                userRoleId: userRoleId,
                doctorId: doctorId
            })
        );
    };

    const getSearchedAppointmentFun = (value) => {
        setSearchKey(value.trim());
        index(1, value.trim(), length, filterDate.startDate, filterDate?.endDate, status, selectedRole?._id, currentDoctor);
    };

    const handleKeyDown = (event) => {
        if ((event.key == "Enter" && keyRef?.current?.id == "appointment-page")) {
            event.preventDefault();
            getSearchedAppointmentFun(searchKey)
        }
    }

    useEffect(() => {
        if (searchKey)
            document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [searchKey]);

    // const appointmentSearchWithTimeOut = (event) => {
    //     clearTimeout(timeoutIdRef.current);
    //     timeoutIdRef.current = setTimeout(() => { getSearchedAppointmentFun(event) }, 700);
    // };

    const createVisitAndNavigate = (appointment) => {
        createVisit(appointment?._id)
            .then((res) => {
                if (res.status === 200) {
                    navigate(`/appointment/${res?.data?._id}`)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const deleteAppointmentFun = async (appointment) => {
        await deleteAppointment(appointment?._id)
            .then((res) => {
                if (res.status === 200) {
                    index(currentPage, searchKey, length, filterDate.startDate, filterDate?.endDate, status)
                    setEnableButton({ ...enableButton, delete: false })
                    Toast.fire({
                        icon: '',
                        title: "Appointment deleted successfully"
                    })
                    setActionModal(false)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    const filterDateFun = (type, startDate, endDate) => {

        if (type == "current-date") {
            setCurrentDate(true)
            setFilterDate({ startDate: date?.slice(0, 10), endDate: endDate })
            LocalStorageService.delete('')
            setStatus('')
            setCurrentLocation("")
            setCurrentDoctor("")
        } else if (type == 'between-date') {
            setCurrentDate(false)
            var date1 = new Date(startDate);
            var date2 = new Date(endDate);
            var diffDays = date2.getDate() - date1.getDate();
            if (diffDays < 0) {
                endDate = startDate
            }
        }
        setFilterDate({ startDate: startDate, endDate: endDate })
        index(currentPage, searchKey, length, startDate, endDate, status)
    }

    const filterStatusFun = (val) => {
        if (val != "reSet") {
            index(currentPage, searchKey, length, filterDate?.startDate || date?.slice(0, 10), filterDate?.endDate || date?.slice(0, 10), val,)
        } else {
            setStatus('')
            index(currentPage, searchKey, length, filterDate?.startDate || date?.slice(0, 10), filterDate?.endDate || date?.slice(0, 10), '',)
        }
    }

    const locationDoctorFilterFun = (type, value) => {
        // console.log("location", type, value?._id)
        // return
        let doctorId = currentDoctor
        let locationId = currentLocation
        if (type == 'location') {
            setCurrentLocation(value?._id)
            locationId = value?._id
        } else if (type == 'doctor') {
            setCurrentDoctor(value?._id)
            doctorId = value?._id
        } else if (type == 'reset') {
            doctorId = ""
            locationId = ""
            setCurrentLocation("")
            setCurrentDoctor("")
        }

        index(currentPage, searchKey, length, filterDate?.startDate || date?.slice(0, 10), filterDate?.endDate || date?.slice(0, 10), status)
    }

    const changeAppointmentDateFun = async (newDate = "") => {

        await put(`appointment/reschedule/${selectedAppointment?._id}`, { date: newDate || appointmentDate })
            .then((res) => {
                if (res.status === 200) {
                    Toast.fire({
                        icon: '',
                        title: "Appointment date change successfully"
                    })
                    setSelectedAppointment({})
                    setDateChangeModal(false)
                    index(currentPage, searchKey, length, filterDate.startDate, filterDate?.endDate, status)
                    setEnableButton({ ...enableButton, appointmentDate: false })

                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setDateChangeModal(false)
            });
    }

    const setParamsFun = (status_val = status || "", startDate = filterDate.startDate || "", endDate = filterDate?.endDate || "", location = currentLocation || "", doctor = currentDoctor || "") => {
        const url = `/appointment?startDate=${startDate}&endDate=${endDate}&status=${status_val}${location?.length ? ('&location=' + location) : ""}${doctor?.length ? ('&doctor=' + doctor) : ""}`
        navigate(url)
    }

    useMemo(() => {
        if (status || filterDate.startDate || filterDate?.endDate || currentLocation || currentDoctor)
            setParamsFun()
    }, [status, filterDate.startDate, filterDate?.endDate, currentLocation, currentDoctor])

    const initials = (name) => {
        if (!name) return "?";
        const parts = String(name).trim().split(/\s+/);
        const first = parts[0]?.[0] || "";
        const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
        return (first + last).toUpperCase() || "?";
    };

    const avatarPalette = ["#0fac81", "#0573f5", "#5b6cf3", "#e35d8a", "#e8902c", "#8957e5"];
    const avatarColor = (name) => {
        if (!name) return avatarPalette[0];
        let hash = 0;
        for (let i = 0; i < name.length; i++) hash = (hash + name.charCodeAt(i)) % avatarPalette.length;
        return avatarPalette[hash];
    };

    const titleCase = (s) => (s ? s[0].toUpperCase() + s.slice(1) : "");

    return (
        <div>
            {/* -------------- */}
            <section ref={keyRef} id="appointment-page" className="content pt-3 content-wrapper main-content appointment-page-container d-flex">
                <AppointmentFilter locationDoctorFilterFun={locationDoctorFilterFun} filterStatusFun={filterStatusFun} setStatus={setStatus} status={status}
                    setFilterDate={setFilterDate} filterDate={filterDate} filterDateFun={filterDateFun} currentDate={currentDate} current width={"17%"} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="appointment-add d-flex justify-content-between ">

                                        <div className="d-flex">
                                            <button
                                                className="btn appointment-add-button"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    setShow(true);
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    className="appointment-add-button-icon"
                                                    icon={faUserPlus}
                                                ></FontAwesomeIcon>{" "}
                                                New appointment{" "}
                                            </button>
                                            <button
                                                className="btn appointment-add-button ml-2"
                                                onClick={(e) => {
                                                    index()
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    className="appointment-add-button-icon "
                                                    icon={faArrowsRotate}
                                                ></FontAwesomeIcon>{" "}
                                                Refresh
                                            </button></div>
                                        <div className="w-50 d-flex">
                                            <input
                                                className="appointment-search w-75"
                                                placeholder="Search appointment"
                                                type="text"
                                                value={searchKey || ""}
                                                onChange={(e) => {
                                                    setSearchKey(e.target.value)
                                                    // appointmentSearchWithTimeOut(e);
                                                }}
                                            ></input>
                                            <button onClick={() => getSearchedAppointmentFun(searchKey)} className="btn my-0 py-1 mx-2 px-3" style={{ backgroundColor: "#0EAC81", color: "white", fontSize: "13px" }}>Search</button>
                                            <button onClick={() => {
                                                setSearchKey("")
                                                index()
                                            }} className="btn my-0 py-1 mx-2 px-3" style={{ backgroundColor: "#0EAC81", color: "white", fontSize: "13px" }}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                                {/* /.card-header */}
                                <div
                                    className="card-body px-0"
                                    style={{ overflowX: "auto", height: "78vh" }}
                                >
                                    <table
                                        id="example2"
                                        className="table table-hover table-sm table-responsive{-sm|-md|-lg|-xl} appointment-list-table"
                                    >
                                        <thead>
                                            {/* table heading */}
                                            <tr>
                                                <th>Serial</th>
                                                <th>Patient</th>
                                                <th>Patient ID</th>
                                                <th>Appointment Date</th>
                                                <th>Appointment Type</th>
                                                {/* <th>Phone</th> */}
                                                {/* <th>Gender</th> */}
                                                <th>Status</th>
                                                <th>Details</th>
                                                {/* <th className="text-center">Print</th> */}
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading && (
                                                <tr className="appointment-list-table__msg-row">
                                                    <td colSpan={7}>Loading…</td>
                                                </tr>
                                            )}
                                            {!isLoading && noAppointmentFound && (
                                                <tr className="appointment-list-table__msg-row">
                                                    <td colSpan={7}>No appointment found</td>
                                                </tr>
                                            )}
                                            {!isLoading && !noAppointmentFound && allAppointments.appointments?.map((appointment, index) => {
                                                const status = appointment?.status?.toLowerCase() || "unknown";
                                                const isActive = appointment?._id === selectedRow;
                                                return (
                                                    <tr
                                                        key={index}
                                                        className={`status-section ${isActive ? "active-row" : ""}`}
                                                    >
                                                        <td>{appointment?.serial}</td>
                                                        <td>
                                                            <span className="appointment-list-table__pat">
                                                                {/* <span
                                                                    className="appointment-list-table__avatar"
                                                                    style={{ background: avatarColor(appointment?.patientName) }}
                                                                    aria-hidden="true"
                                                                >
                                                                    {initials(appointment?.patientName)}
                                                                </span> */}
                                                                <span className="appointment-list-table__pat-text">
                                                                    <span
                                                                    style={{ color: "black", fontWeight:"600",fontSize:"14px" }}
                                                                     className="appointment-list-table__pat-name">
                                                                        {appointment?.patientName || "—"}
                                                                    </span>
                                                                    {(appointment?.patientGender || appointment?.patientDob) && (
                                                                        <small
                                                                            style={{ color: "black", fontWeight:"500" }}
                                                                            className="appointment-list-table__pat-sub">
                                                                            {appointment?.patientGender ? titleCase(appointment.patientGender) : ""}
                                                                            {appointment?.patientDob ? ` · ${formatAgeYearMonth(appointment.patientDob)}` : ""}
                                                                        </small>
                                                                    )}
                                                                </span>
                                                            </span>
                                                        </td>
                                                        <td style={{ color: "black",fontWeight:"600" }}>{appointment?.patient?.patientId || "—"}</td>
                                                        <td
                                                            style={{ color: "black",fontWeight:"500"     }}
                                                            className="appointment-list-table__date-cell">
                                                            {appointment?.date ? formatDate(appointment.date.slice(0, 10)) : "—"}
                                                        </td>
                                                        <td className="appointment-list-table__type-cell">
                                                            {appointment?.type ? (
                                                                <span
                                                                    className={`appointment-list-table__type-badge appointment-list-table__type-badge--${appointment.type.toLowerCase()}`}
                                                                >
                                                                    {appointment.type === "followUp" ? "Follow up" : titleCase(appointment.type)}
                                                                </span>
                                                            ) : (
                                                                <span className="appointment-list-table__muted">—</span>
                                                            )}
                                                        </td>
                                                        <td 
                                                            style={{ color: "black",fontWeight:"500"     }}
                                                        className="appointment-list-table__status-cell">
                                                            <span
                                                                className={`appointment-list-table__status-badge appointment-list-table__status-badge--${status}`}
                                                            >
                                                                <span className="appointment-list-table__status-dot"
                                                                    aria-hidden="true" />
                                                                {appointment?.status ? titleCase(appointment.status) : "Unknown"}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                style={{ color: "black",fontWeight:"500"     }}
                                                                type="button"
                                                                className="appointment-list-table__visit-btn"
                                                                onClick={() => createVisitAndNavigate(appointment)}
                                                            >
                                                                <FontAwesomeIcon size="sm" icon={faEye} />
                                                                View
                                                            </button>
                                                        </td>
                                                        <td className="text-center appointment-list-table__action-cell">
                                                            <button
                                                                style={{ color: "black",fontWeight:"500"     }}
                                                                type="button"
                                                                className="appointment-list-table__action-icon"
                                                                aria-label="Edit appointment"
                                                                onClick={() => {
                                                                    setSelectedAppointment(appointment);
                                                                    setActionModal(true);
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPenToSquare} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                {/* /.card-body */}
                                <div className="card-footer">
                                    <div className="float-left">
                                        <div
                                            className="dataTables_info"
                                            id="example2_info"
                                            role="status"
                                            aria-live="polite"
                                        >
                                            <>
                                                <select
                                                    defaultValue={50}
                                                    onChange={(e) => {
                                                        setLength(e.target.value);
                                                        index(1, "", e.target.value, filterDate.startDate, filterDate?.endDate, status);
                                                    }}
                                                >
                                                    {/* <option value={5}>5 entries </option> */}
                                                    <option value={10}>10 entries</option>
                                                    <option value={20}>20 entries</option>
                                                    <option value={50}>50 entries</option>
                                                    <option value={100}>100 entries</option>
                                                </select>{" "}
                                                &nbsp; Showing {((filterLocalData?.currentPage || currentPage) - 1) * (filterLocalData?.perPage || perPage) + 1} to{" "}
                                                {total > (filterLocalData?.currentPage || currentPage) * (filterLocalData?.perPage || perPage)
                                                    ? currentPage * (filterLocalData?.perPage || perPage)
                                                    : total}{" "}
                                                of {total} entries
                                            </>
                                        </div>
                                    </div>
                                    <div className="float-right">
                                        {noAppointmentFound && !isLoading ? (
                                            ""
                                        ) : (
                                            <div className="d-flex justify-content-center">
                                                <Pagination
                                                    activePage={parseInt((filterLocalData?.currentPage || currentPage))}
                                                    itemsCountPerPage={parseInt((filterLocalData?.perPage || perPage))}
                                                    totalItemsCount={parseInt(total)}
                                                    // pageRangeDisplayed={5}
                                                    onChange={(currentPage) => {
                                                        index(currentPage, "", length);
                                                    }}
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container-fluid */}
            </section>
            {/*  modal */}
            <CustomModal
                customClass="appointment"
                size="xl"
                show={show}
                setShow={setShow}
                isHeader={false}
                isHeaderHide={true}
            >
                <CreateAppointment
                    setShow={setShow}
                    refresh={index}
                />
            </CustomModal>

            <CustomModal
                size="xl"
                show={showPrint}
                setShow={setShowPrint}
                isHeader={true}
                isHeaderHide={true}
            >
                <PrescriptionPrint setShowPrint={setShowPrint} patientId={patientId} visitId={visitId}></PrescriptionPrint>
            </CustomModal>

            <CustomModal
                size="md"
                show={dateChangeModal}
                setShow={setDateChangeModal}
                isHeader={true}
            >
                <div>
                    <h6 className="text-center pt-3">Appointment date reschedule from <span
                        className="text-danger">{dateFormat(selectedAppointment?.date?.slice(0, 10))}</span> to <span className="text-success">{dateFormat(appointmentDate)}</span>
                        <br />
                        Are you sure ?</h6>
                    <div className="d-flex justify-content-center mb-0 pb-0">
                        <p onClick={() => {
                            changeAppointmentDateFun()
                        }} className="success px-4 mr-2">Yes</p>
                        <p onClick={() => {
                            setDateChangeModal(false)
                        }} className="cancel">No</p>
                    </div>
                </div>
            </CustomModal>
            <CustomModal
                size="md"
                show={actionModal}
                setShow={setActionModal}
                isHeader={true}
                isHeaderHide={true}
            >
                <div className="appointment-update-modal">
                    <header className="appointment-update-modal__header">
                        <div>
                            <h2 className="appointment-update-modal__title">Edit appointment</h2>
                            <p className="appointment-update-modal__subtitle">
                                Update patient details, status, date, and visit type.
                            </p>
                        </div>
                        <button
                            type="button"
                            className="appointment-update-modal__close"
                            onClick={() => setActionModal(false)}
                            aria-label="Close"
                        >
                            <FontAwesomeIcon icon={faXmark} />
                        </button>
                    </header>
                    <div className="appointment-update-modal__body">
                        <AppointmentDetailsShow
                            setActionModal={setActionModal}
                            reset={index}
                            setAppointmentUpdatedValue={setAppointmentUpdatedValue}
                            appointmentUpdatedValue={appointmentUpdatedValue}
                            setSelectedAppointment={setSelectedAppointment}
                            selectedAppointmentInfo={selectedAppointment}
                        />
                    </div>
                    <div className="appointment-update-modal__danger">
                        <div className="appointment-update-modal__danger-head">
                            <span className="appointment-update-modal__danger-icon-wrap" aria-hidden="true">
                                <FontAwesomeIcon icon={faTriangleExclamation} className="appointment-update-modal__danger-icon" />
                            </span>
                            <div className="appointment-update-modal__danger-copy">
                                <p className="appointment-update-modal__danger-title">Remove this appointment</p>
                                <p className="appointment-update-modal__danger-desc">
                                    Deleted appointments cannot be recovered. Enable the option below, then confirm.
                                </p>
                            </div>
                        </div>
                        <div className="appointment-update-modal__danger-actions">
                            <label htmlFor="check-1" className="appointment-update-modal__checkbox-label">
                                <input
                                    id="check-1"
                                    className="appointment-update-modal__checkbox-input"
                                    checked={enableButton?.delete || false}
                                    onChange={() => {
                                        setEnableButton({ ...enableButton, delete: !enableButton?.delete });
                                    }}
                                    type="checkbox"
                                />
                                <span>I understand — allow delete</span>
                            </label>
                            <button
                                type="button"
                                className="btn btn-danger appointment-update-modal__delete-btn"
                                disabled={!enableButton?.delete}
                                onClick={() => deleteAppointmentFun(selectedAppointment)}
                            >
                                <FontAwesomeIcon icon={faTrash} className="me-1" />
                                Delete appointment
                            </button>
                        </div>
                    </div>
                </div>
            </CustomModal>
        </div>
    );
};

export default Appointment;

